module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_yoso_studio@2x-27b68c808a5d3fc3b7ba297272998759.webp";